// extracted by mini-css-extract-plugin
export default {"body":"TableBody_body__vtrQb","empty":"TableBody_empty__XbQL4"};